<template>
  <div>
    <el-row>
      <el-col :span="15" :xs="24">
        <div v-if="isEdit">
          <el-input placeholder="Please input" v-model="program.title">
            <el-button type v-on:click="update" slot="append">Save</el-button>
          </el-input>
        </div>
        <div v-else>
          <el-row>
            <el-col :sm="18" :xs="15" class="grid-content"></el-col>
            <el-col :sm="6" :xs="8">
              <el-button type="warning" icon="el-icon-edit" circle v-on:click="isEdit=true"></el-button>
              <el-button type="danger" icon="el-icon-delete" circle v-on:click="remove"></el-button>
            </el-col>
          </el-row>
        </div>

        <div style="padding-top:15px;">
          <codemirror
            ref="myCm"
            v-model="program.snippet"
            :options="cmOptions"
            @ready="onCmReady"
            @focus="onCmFocus"
            @input="onCmCodeChange"
          ></codemirror>
        </div>
        <div>
          <br>
          <el-button v-on:click="runProgram" type="primary">Run</el-button>
        </div>
      </el-col>
      <el-col
        :span="9"
        :xs="24"
        :style="{paddingLeft:isMobile?'':'30px',paddingTop:'15px',maxHeight:'300px'}"
      >
        <div>
          <h4>Output</h4>
        </div>
        <div style="overflow-y:scroll">
          <div style="max-height:300px">
            <div v-for="log in output" :key="log">{{log}}</div>
            <div v-if="error && error.message" style="color:red">{{error}} {{error.stack}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from "@/api";
import _ from "underscore";
export default {
  props: ["program", "index", "isMobile"],
  data() {
    return {
      error: {},
      isEdit: false,
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: "text/javascript",
        theme: "monokai",
        lineNumbers: true,
        styleActiveLine: true,
        extraKeys: { Ctrl: "autocomplete" },
        line: true
        // extraKeys: {
        //   Ctrl: "autocomplete"
        // }
        // keyMap: "sublime",
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      output: []
    };
  },
  methods: {
    async update() {
      // this.$store.commit("update", this.program.id, {
      //   title: this.program.title
      // });

      await api.updateCode(this.program._id, this.program);

      this.isEdit = false;
    },
    remove() {
      var txt;
      var r = confirm(
        "Are you sure want to delete '" + this.program.title + "'"
      );
      if (r == true) {
        // this.$store.commit("remove", this.program.id);
        this.$emit("delete", this.program._id);
      }
    },
    runProgram() {
      console.log("runProgram");
      var that = this;
      var old = console.log;
      this.output = [];
      console.log = function() {
        var output = "";
        for (var i = 0; i < arguments.length; i++) {
          if (typeof arguments[i] == "object") {
            output +=
              JSON && JSON.stringify
                ? JSON.stringify(arguments[i], undefined, 2)
                : arguments[i];
          } else {
            output += arguments[i] + "   ";
          }
        }
        that.output.push(output);
      };

      try {
        eval(this.snippet);
        // console.log = old;
        this.error = {};

      } catch (e) {
        this.error = e;
       
      }finally{
        console.log = old;
      }
    },
    onCmReady(cm) {
      cm.on("keypress", () => {
        cm.showHint({ completeSingle: false });
      });
    },
    onCmFocus(cm) {
      //   cm.showHint();
      // console.log("the editor is focus!", cm);
    },
    onCmCodeChange: _.debounce(async function(newCode) {
      // console.log("this is new snipeet", newCode);
      this.snippet = newCode;
      this.program.snippet = newCode;
      await api.updateCode(this.program._id, this.program);
      // this.$store.commit("update", this.program.id, { snipeet: this.snipeet });
    }, 1000)
  },
  created() {
    this.snippet = this.program.snippet;
    // this.runProgram();
  },
  computed: {
    codemirror() {
      return this.$refs.myCm.codemirror;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CodeUnit.vue